import {
  Component,
  ChangeDetectionStrategy,
  InputSignal,
  input,
} from '@angular/core';
import { StatusColum } from '../../models/simple-table-model';

@Component({
  selector: 'app-status-column',
  templateUrl: './status-column.component.html',
  styleUrls: ['./status-column.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusColumnComponent {
  /**
   * Receive a object with the status and configurations for each one for translating it
   * status = analise | 1933
   * @example
   * statusConfiguration: {
   *   analise: {
   *    color: 'red',
   *    description: 'Analise'
   *   },
   *   aprovado: {
   *    color: 'green',
   *    description: 'Aprovado'
   *   },
   * }
   *
   */

  readonly config: InputSignal<{
    [key: string]: StatusColum;
  }> = input<{
    [key: string]: StatusColum;
  }>({
    analise: {
      color: '#00b8ef',
      description: 'Análise',
      icon: 'search',
    },
  });

  readonly value: InputSignal<string> = input<string>('analise');
}
